import React, { useEffect, useState } from 'react'
import './MenuFiltro.scss'
// import bebidas from './Images/bebidas.svg'
// import carnes from './Images/carnes.svg'
// import todos from './Images/todos.svg'
// import hortifruti from './Images/hortifruti.svg'
// import mercearia from './Images/mercearia.svg'
// import bazar from './Images/bazar.svg'
// import limpeza from './Images/limpeza.svg'
// import produtosdia from './Images/produtos-dia.svg'
// import pet from './Images/pet.svg'
// import iconLocal from './Images/iconLocal.svg'
// import favorito from './Images/fav.svg'
// import { Link } from 'gatsby's
import Swiper from 'react-id-swiper'

const Molde = (props) => (
  <div
    className={props.active === props.filtro ? 'col nav-op-ofertas-active' : 'col nav-op-ofertas'}
    id={props.categoria}
    onClick={() => props.changeFilter(props.categoria)}
  >
    <button className="pb-lg-0 pt-lg-2 pb-4">
      <img className="d-flex mx-auto icone" src={props.imagem} alt="imagem" />
      <span className="font-Yanone font-size-1" style={{ color: '#1B7796', textTransform: 'none', lineHeight: '12px' }}>{props.categoria.name}</span>
    </button>
  </div>
)

export default function Menu (data) {
  const swiperParams = {
    slidesPerView: 4,
    spaceBetween: 5,
    slidesPerGroup: 3,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  }

  // console.log(data.categorias)
  const _categorias = data.categorias.filter((cat) => cat.type !== 'BANNER' && cat.exibe)
  // console.log(_categorias)
  const [active, setActive] = useState()
  useEffect(() => {
    const cat = data.categorias.filter((cat) => cat.type === 'TODOS')[0]
    console.log(cat)
    setActive(cat.id)

    data.handleFilter(cat)
  }, [])

  const setFiltro = (categoria) => {
    setActive(categoria.id)
    data.handleFilter(categoria)
  }

  return (
    <>
      <div className="ofertasDesktop">
        <nav id="nav-ofertas" className="text-center mb-3 d-flex align-items-end">
          <div className="container">
            <div className="row no-gutters">
              {_categorias.map((cat) => {
                return (
                  <Molde
                    categoria={cat}
                    imagem={cat.icon && cat.icon.url}
                    filtro={cat.id}
                    changeFilter={setFiltro}
                    active={active}
                  />
                )
              })}
            </div>
          </div>
        </nav>
      </div>
      <div className="ofertasMobile custom-stick-top">
        <nav id="nav-ofertas" className="text-center mb-3">
          <div className="container">
            <div className="row justify-content-center" id="swiper-mobile-categorias">
              <Swiper {...swiperParams}>
                {_categorias.map((cat) => {
                  return (
                    <div className={active === 'Todos' && 'background-menu-white-mob'} key={cat.name}>
                      <Molde
                        categoria={cat}
                        imagem={cat.icon && cat.icon.url}
                        filtro={cat.id}
                        changeFilter={setFiltro}
                        active={active}
                      />
                    </div>
                  )
                })}
              </Swiper>
            </div>
          </div>
        </nav>
      </div>
    </>
  )
}
